import React, { Fragment, useEffect, useState } from 'react';

import {
  Validator,
  PatternRule
} from 'devextreme-react/validator';

import 'devextreme-react/autocomplete';
import 'devextreme-react/date-range-box'; 
import OTPLogin from './otp-login';
import { persianLanguage } from '../../../../constants/persianTerms';
import { generalErrorMessage } from '../../../errors/general-errors/general-errors';
import axios from 'axios';
import { BASE_API, CAPTCHA_API } from '../../../../constants/api';
import { errorNotify } from '../../../../shared/notifications';
import { useAuth } from '../../auth-provider/auth-provider';
import { useNavigate } from 'react-router-dom';
import './enter-mobile-number.css';
import { Button, SelectBox, TextBox } from 'devextreme-react';
import { mobileNumberValidation } from '../../../../shared/dataValidation';
import { makeArrayUnique, removeEmptyMembersFromArray } from '../../../../shared/array-functions';
import { iranianMobileRegex } from '../../../../shared/regex-patterns';
import SpinnerLoading from '../../../components/spinner-loading/SpinnerLoading';
import { consoleLog } from '../../../../shared/utils';

export default function EnterMobileNumber(){
  
    const  otpUrlApi = `${BASE_API}otp/`;
    const auth = useAuth();
    const navigate = useNavigate()
    
    const [mobileNumbers, setMobileNumbers] = useState(JSON.parse(localStorage.getItem('mobileNumbers')) || []);
    const [mobileNumber, setMobileNumber] = useState(null);
    const [popupVisible, setPopupVisible] = useState(false)
    const [mobile, setMobile] = useState("");

    const [captchaNumbers, setCaptchaNumbers] = useState(null);
    const [captchaSolution, setCaptchaSolution] = useState(null);

    const [wrongCaptchaSolution, setWrongCaptchaSolution] = useState(null);

    const [errorMessage, setErrorMessage] = useState(null);
    const [isDisabled, setIsDisabled] = useState(false);        
    const [uniqueArray, setUniqueArray] = useState(null);

    useEffect(() => {
      if(auth?.token){
        navigate('/');
      }
      if(mobileNumbers && mobileNumbers.length > 0){
        setMobileNumber(mobileNumbers[0])
        createNewCaptcha();
      } else {
        createNewCaptcha();
      }
     },[auth?.token]);

     function enableIsDisabled(){
      setTimeout(function(){ 
          setIsDisabled(false); 
      }, 2000);
    }

     const handleSubmit =(e) => {
      setIsDisabled(true);
      if(mobileNumber && captchaSolution){
        setMobile(mobileNumber);
        mobileNumberForOTPAction();
      } else{
        setIsDisabled(false);
      }
      if (uniqueArray && uniqueArray.length > 0){
        setMobileNumbers(uniqueArray);
      }

      if('mobileNumbers' in localStorage){
        localStorage.removeItem('mobileNumbers');
      }
      localStorage.setItem('mobileNumbers', JSON.stringify(mobileNumbers));
    };
    
    const mobileNumberForOTPAction = () => {
      const formData =  {
        "mobileNumber": mobileNumber,
        "captcha": captchaSolution,
      }
      if(formData.mobileNumber && formData.captcha){
        axios.post(otpUrlApi, formData).then(
          (response) => {
            setPopupVisible(true);
            setMobile(mobileNumber);
            setErrorMessage(null);
          }
      ).catch(
          (error) => {
            enableIsDisabled();
              if(error.response){
                if(error.response.status === 401 || error.response.status === 412 ||  error.response.status === 406){
                  setErrorMessage('اطلاعات ارسال شده نادرست است مجدد تلاش کنید.');
                } else if(error.response.status === 406){
                  setWrongCaptchaSolution(error.response.data)
                  setCaptchaSolution(null);
                } else if (error.response.status === 403) {
                  setErrorMessage(persianLanguage.phrase.error.ERROR_403);
                } else {
                  const message = generalErrorMessage(error.response.status)
                  errorNotify(message);
                }
              }
          }
      );
      }
  }

  const createNewCaptcha = () => {
    axios.get(`${CAPTCHA_API}new/`).then(
      response => {
          setCaptchaSolution('');
          setCaptchaNumbers(response.data);
          consoleLog({'resp data': response.data})
          // setCaptchaLabel(`${persianDigitPrice(response.data.secondNumber)} ${response.data.summationSignCharacter} ${persianDigitPrice(response.data.firstNumber)}`);
          // setCaptchaFirstNumber(response.data.firstNumber);
          // setCaptchaSecondNumber(response.data.secondNumber);
          // setCaptchaSign(response.data.summationSignCharacter);
          setWrongCaptchaSolution(null);
      }
    ).catch(
      error => {
      }
    )
  }

  const popupToParent = (value) => {
    setPopupVisible(value);
    setMobileNumber(mobileNumber);
    setIsDisabled(false);
    createNewCaptcha();
    setCaptchaSolution(null);
    setWrongCaptchaSolution(null);
  }

  const mobileToParent = (value) => {
    setPopupVisible(value);
    setCaptchaSolution(null);
    setMobileNumber(null);
  }
    
  const handleMobileNumberChange = (e) => {
    if(e.event.target.value){
      setCaptchaSolution(null);
      const result = mobileNumberValidation(e.event.target.value);

      if (result['status'] === 200){
        createNewCaptcha();
        setMobileNumber(result["value"]);

        let mobileNumberArray = mobileNumbers;
        mobileNumberArray.push(result['value'])
        if (mobileNumberArray.length > 0){
          let filteredArray = removeEmptyMembersFromArray(mobileNumberArray)
          const tempUniqueArray = makeArrayUnique(filteredArray);
          setUniqueArray(tempUniqueArray)
          // setMobileNumbers(uniqueArray);          
        }
      }
    }    
  }

  const handleCaptchaChange = (e) => {
    if(e.value){
      setCaptchaSolution(e.value)
    } else {
      setCaptchaSolution(null)
    }
  }

  const handleMobileItemSelection = (e) => {
    if(e?.itemData){
      const result = mobileNumberValidation(e.itemData);
      if (result['status'] === 200){
        createNewCaptcha();
        setMobileNumber(result["value"]);
      }
    }    
  }
  if(captchaNumbers){
    return (
      <Fragment>
  
      <div className="grid md:grid-cols-5 lg:grid-cols-3 sm:grid-cols-12">
        <div className="lg:col-span-1 md:col-span-1 sm:col-span-1"></div>
        <div className="lg:col-span-1 md:col-span-3 sm:col-span-10">
        <div className="flex items-center justify-center h-screen">
        <form action='login' className='border border-primary-third p-5' onSubmit={handleSubmit}>
      
        <span>{captchaNumbers?.firstNumber}</span>
        <span>{captchaNumbers?.secondNumber}</span>
          <div className='border-b border-primary-fourth mb-5' >{persianLanguage.word.general.ENTER}</div>
          {mobileNumbers.length > 0 &&
            <SelectBox
            name='mobileNumber'
            items={mobileNumbers}
            label={`${persianLanguage.word.user.MOBILE_NUMBER}`}
            labelMode='floating'
            acceptCustomValue={true}
            maxLength={11}
            defaultValue={mobileNumber}
            onItemClick={handleMobileItemSelection}
            onKeyUp={handleMobileNumberChange}
            className='bg-primary-second'
            >
              <Validator>
                <PatternRule 
                  pattern={iranianMobileRegex}
                  message={persianLanguage.phrase.error.ERROR_MOBILE_NUMBER_WRONG_FORMAT}
                >
                </PatternRule>
              </Validator>
            </SelectBox>
          }
          {mobileNumbers.length === 0 &&
            <TextBox
            name='mobileNumber'
            label={`${persianLanguage.word.user.MOBILE_NUMBER}`}
            labelMode='floating'
            placeholder={`${persianLanguage.word.user.MOBILE_NUMBER}`}
            valueChangeEvent="keyup"
            onKeyUp={handleMobileNumberChange}
            className='bg-primary-second'
            >
              <Validator>
                <PatternRule 
                  pattern={iranianMobileRegex}
                  message={persianLanguage.phrase.error.ERROR_MOBILE_NUMBER_WRONG_FORMAT}
                >
                </PatternRule>
              </Validator>
            </TextBox>
          }

          {
            mobileNumber
            &&
            <div className="grid grid-cols-1 md:grid-cols-8 justify-stretch gap-1 mt-5">
              <div className='grid-cols-1 md:col-span-3 h-full' >
                <TextBox
                  name='captcha'
                  value={captchaSolution}
                  className='h-full bg-primary-second'
                  label={`مقدار کپچا را وارد کنید`}
                  labelMode='hidden'
                  placeholder={`مقدار کپچا را وارد کنید`}
                  valueChangeEvent="keyup"
                  onValueChanged={handleCaptchaChange}
                />
              </div>
              <div className='flex grid-cols-1 md:col-span-4 items-center justify-center border rounded'>
              {captchaNumbers &&
                <img 
                class="rounded-md h-full"
                height={`100% !important`}
                width={`100%`} src={captchaNumbers.url} />  
              }
              </div>

              <div className='grid-cols-1 md:col-span-1 items-center justify-center border border-primary-main'>
                <Button
                  width='100%'
                  icon='refresh'
                  className='bg-primary-main no-border-btn rounded-[24px]'
                  onClick={createNewCaptcha} 
                />  
              </div>
            </div>
          }
            
          <div className='enter-mobile-submit-btn'>
            <Button        
              disabled={isDisabled}
              width='100%'
              id='mobileSubmitId'
              className='flex justify-content white bg-success-main no-border-btn mt-5'
              onClick={handleSubmit}       
            >
              <div>
                {persianLanguage.word.general.ENTER}
                <SpinnerLoading isSpinning={isDisabled} />
              </div>
            </Button>
          </div>
            {errorMessage && <span className='bg-red-100 border border-red-400 text-red-700 px-2 mt-5 rounded'>{errorMessage}</span>}
            {wrongCaptchaSolution && <span className='bg-red-100 border border-red-400 text-red-700 px-2 mt-5 rounded'>{wrongCaptchaSolution}</span>}
        </form>                
        </div>
        </div>
        <div className="lg:col-span-1 md:col-span-1 sm:col-span-1"></div>
      </div>
      {popupVisible &&
        <OTPLogin 
        popupValue={popupVisible}
        mobile={mobile}
        popupToParent={popupToParent}
        mobileToParent={mobileToParent}
        />
      } 
  
      </Fragment>
  );    
  
  } else {
    return <Fragment>
      <SpinnerLoading  isSpinning={true}/>
    </Fragment>
  }

}